import { render, staticRenderFns } from "./dragonBoat.vue?vue&type=template&id=157564ae&scoped=true&"
import script from "./dragonBoat.vue?vue&type=script&lang=js&"
export * from "./dragonBoat.vue?vue&type=script&lang=js&"
import style0 from "./dragonBoat.vue?vue&type=style&index=0&id=157564ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "157564ae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data-jenkins/jenkins/workspace/html-cube-webapi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('157564ae')) {
      api.createRecord('157564ae', component.options)
    } else {
      api.reload('157564ae', component.options)
    }
    module.hot.accept("./dragonBoat.vue?vue&type=template&id=157564ae&scoped=true&", function () {
      api.rerender('157564ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/MarketingActivityEdit/ActivePages/dragonBoat.vue"
export default component.exports